import { ContentObjectItem } from "@vertesia/common"
import { FileSearch } from "lucide-react"

import { ActionTooltipButton } from "@components/buttons/ActionTooltipButton"
import { DocumentSelectionOverlay } from "@components/overlays/DocumentSelectionOverlay"

interface SearchDocumentsButtonProps {
    onSelection?: (document: ContentObjectItem) => void
    onMultipleSelection?: (documents: ContentObjectItem[]) => void
}
export function SearchDocumentsButton({ onSelection, onMultipleSelection }: Readonly<SearchDocumentsButtonProps>) {
    const handleOnDocumentSelection = (value: ContentObjectItem) => {
        onSelection?.(value)
    }

    const handleOnMultipleDocumentSelection = (value: ContentObjectItem[]) => {
        onMultipleSelection?.(value)
    }

    return (
        <DocumentSelectionOverlay onObjSelection={onSelection ? handleOnDocumentSelection : undefined} onObjMultipleSelection={onMultipleSelection ? handleOnMultipleDocumentSelection : undefined}>
            <ActionTooltipButton variant="outline" size="icon" icon={<FileSearch />} tooltip={`Select Document${onMultipleSelection ? "(s)" : ""}`} onClick={() => {}} className="size-9" />
        </DocumentSelectionOverlay>
    )
}
